import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { S3URL } from "../../../data/globalConstants";
import GenreShowAwardsCarousel from "./GenreShowAwardsCarousel";
import { isMobile, isTablet } from "react-device-detect";
import { useGuildPath } from "../../../utils/Guild/useGuild";

export default function GenreShow({
  show,
  hasAwards,
  genreSlug,
  activeGenre,
  featured,
}) {
  const awardsRef = useRef();
  const guildPath = useGuildPath();

  const [showGenres, setShowGenres] = useState([]);

  const disableHover = isMobile || isTablet;

    useEffect(() => {
        if (!show?.genres?.[0]) return;

        try {
            const parsed = JSON.parse(`[${show.genres[0]}]`);

            const hasNonfictionSeries = parsed.some(
                (genre) => genre.slug === "nonfiction-series"
            );

            const filteredNonfiction =
                parsed.length > 1 && !hasNonfictionSeries
                    ? parsed.filter((genre) => genre.slug !== "nonfiction")
                    : parsed;

            const filtered = activeGenre
                ? filteredNonfiction.filter(
                    (genre) => genre.slug !== activeGenre.slug
                )
                : filteredNonfiction;

            setShowGenres(filtered);
        } catch (err) {
            // console.error("Failed to parse genres:", err);
            setShowGenres([]);
        }
    }, [show?.genres, activeGenre]);

  const handleMouseEnter = (e) => {
    if (disableHover) return;
    if (!activeGenre) return;
    const targetEl = e.currentTarget.querySelector(".genre-show-a");
    targetEl.style.boxShadow = `rgba(${activeGenre?.theme?.colors?.light?.rgb},.7) 0px 0px 30px`;
    document.querySelectorAll(".genre-show").forEach((el) => {
      if (el !== e.currentTarget) el.classList.add("dimmed");
    });
    if (!hasAwards) return;
    awardsRef.current?.startAnimation();
  };

  const handleMouseLeave = (e) => {
    if (disableHover) return;
    if (!activeGenre) return;
    const targetEl = e.currentTarget.querySelector(".genre-show-a");
    targetEl.style = {};
    document
      .querySelectorAll(".genre-show")
      .forEach((el) => el.classList.remove("dimmed"));
    if (!hasAwards) return;
    awardsRef.current?.stopAnimation();
  };

  const renderShowGenres =
    featured && showGenres?.length > 0 ? (
      <div className="genre-show-genres">
        {showGenres?.map((genre) => (
          <span key={genre.slug}>{genre?.title}</span>
        ))}
      </div>
    ) : null;

  const renderAwardsCarousel =
    hasAwards && featured && show?.slug && genreSlug ? (
      <GenreShowAwardsCarousel
        ref={awardsRef}
        show={show}
        genreSlug={genreSlug}
        featured={featured}
      />
    ) : null;

  return (
    <div
      className={
        "genre-show " +
        (hasAwards ? "has-awards " : "") +
        (featured ? "genre-featured " : "") +
        (showGenres.length ? "has-subgenre " : "")
      }
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link
        to={guildPath("/" + genreSlug + "/" + show.slug)}
        aria-label={`${show.title}`}
        className={"genre-show-a"}
      >
        <img
          src={S3URL + show.keyArt}
          alt={show.title}
          className={"genre-ka"}
        />
        {renderAwardsCarousel}
        {renderShowGenres}
      </Link>
    </div>
  );
}
